import { render, staticRenderFns } from "./Singup.vue?vue&type=template&id=6522e342&scoped=true&"
import script from "./Singup.vue?vue&type=script&lang=js&"
export * from "./Singup.vue?vue&type=script&lang=js&"
import style0 from "./Singup.vue?vue&type=style&index=0&id=6522e342&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6522e342",
  null
  
)

export default component.exports